import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import type { ChallengeFirmaDTO, EvidenciaConectividad } from '@ausentia/shared';
import { api, ErrorApi } from '../api/cliente.js';
import { descripcionDispositivo } from '../almacen/red.js';

interface ControlPendiente {
  controlId: string;
  constanciaCodigo: string | null;
  trabajador: string;
  fechaControl: string;
  adjuntos: number;
  evidenciaConectividad: EvidenciaConectividad | null;
}

export function Acta() {
  const navegar = useNavigate();
  const [pendientes, setPendientes] = useState<ControlPendiente[] | null>(null);
  const [error, setError] = useState('');
  const [generando, setGenerando] = useState(false);

  useEffect(() => {
    api
      .get<ControlPendiente[]>('/api/controles/contingencia-pendiente')
      .then(setPendientes)
      .catch((err) => setError(err instanceof ErrorApi ? err.message : String(err)));
  }, []);

  async function generar() {
    if (!pendientes || pendientes.length === 0) return;
    setGenerando(true);
    setError('');
    const intentos = pendientes.flatMap((p) => p.evidenciaConectividad?.intentosFallidos ?? []);
    try {
      const r = await api.post<{ codigo: string; challenge: ChallengeFirmaDTO }>('/api/actas-contingencia', {
        controlIds: pendientes.map((p) => p.controlId),
        evidenciaConectividad: {
          estadoRed: 'SIN_SERVICIO',
          intentosFallidos: intentos.slice(0, 100),
          dispositivo: descripcionDispositivo(),
        },
      });
      navegar('/medico/firma', { state: { codigo: r.codigo, challengeId: r.challenge.challengeId, metodo: r.challenge.metodo } });
    } catch (err) {
      setError(err instanceof ErrorApi ? err.message : String(err));
      setGenerando(false);
    }
  }

  return (
    <>
      <div className="barra-titulo">
        <button className="volver" onClick={() => navegar('/medico/pendientes')}>‹</button>
        <span>Acta de digitalización y contingencia</span>
      </div>
      <div className="contenido">
        <div className="aviso-info">
          <span>⚖️</span>
          <span>
            El Dec. 407/2026 admite el papel solo ante contingencia <strong>debidamente acreditada</strong>. Al firmar esta
            acta se adjunta la evidencia automática de la falta de conectividad y los hashes de las fotos, cerrando la
            cadena de custodia.
          </span>
        </div>

        {pendientes === null && <div className="cargando">Cargando…</div>}
        {pendientes && pendientes.length === 0 && (
          <p className="muted" style={{ marginTop: 12 }}>No hay constancias en papel pendientes de acta.</p>
        )}

        {pendientes?.map((p) => (
          <div key={p.controlId} className="tarjeta">
            <p style={{ margin: 0, fontWeight: 600, fontSize: 14 }}>{p.trabajador || p.constanciaCodigo}</p>
            <p className="muted" style={{ margin: '3px 0 0' }}>
              {p.constanciaCodigo} · control del {p.fechaControl} · {p.adjuntos} foto(s)
            </p>
            {p.evidenciaConectividad && (
              <p className="mini" style={{ margin: '6px 0 0' }}>
                Estado de red: {p.evidenciaConectividad.estadoRed} · {p.evidenciaConectividad.intentosFallidos.length} intento(s) fallido(s) registrados
              </p>
            )}
          </div>
        ))}

        {error && <div className="error-box">{error}</div>}
        {pendientes && pendientes.length > 0 && (
          <button className="primario" onClick={generar} disabled={generando}>
            {generando ? 'Generando…' : 'Generar y firmar acta'}
          </button>
        )}
      </div>
    </>
  );
}
